module.exports = __webpack_public_path__ + "images/category_lp/watch/omega_samples/sec03_sp_1ddbf57eb194fb97811c08bcc9de9afd.jpg";